import { PaginaNode, TecnologiaNode } from '@gql/graphql'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import { MenuItemType } from '../../../utils/types'
import styles from './TecnologieHubTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  tecnologie?: TecnologiaNode[]
}

const TecnologieHubTemplate = (props: Props) => {
  const { pagina = undefined, tecnologie = [] } = props

  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <Prefooter />
      </main>
    </Page>
  )
}

export default TecnologieHubTemplate
